import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import ToggleSwitch from './ToggleSwitch'
import Skeleton from 'react-loading-skeleton'
import actions from '../actions/index'
import { GeneralPaddle, MajorDealPaddle, PressRoundUpPaddle } from "./Paddle"
import { MAXCONTENTSETLIMIT } from "../utils/constants"
import PortfolioPaddle from './Paddle/PortfolioPaddle'
import SavedSearchPaddle from './Paddle/SavedSearchPaddle'
import { Card, CardHeader, CardBody } from './Card'
require('../../images/plus_symbol.svg')

var ES6Promise = require('es6-promise')
ES6Promise.polyfill()

export class UserPreferences extends Component {

  componentDidMount() {
    document.title="MLex | Content and Alerts Selection"
    if (this.props.user) {
      this.props.onFetch().then(() => {
      })
    }

    window.scrollTo(0, 0)
  }

  saveUserPreferences = (currentSubscribedAlert) => {
    const request = () => {
      return {
        ...this.props.preferences,
        subscribedAlerts: currentSubscribedAlert
      }
    }

    this.props.preferences.subscribedAlerts = currentSubscribedAlert

    this.props.onSubmit(request())
  }

  render() {
    if (this.props.user) {
      if (this.props.preferences.error != '') {
        this.props.preferences.error = ''
        return <Redirect to='/error' />
      }
      else {
        if (this.props.preferences.subscribedAlerts != null) {
          return (
            <div className='content content-user-preferences grid-content-full'>
              <div className='inner-container'>
                <h1 className="section-header">Content and Alerts Selection</h1>
                <p>Manage your alerts from this page.<br /></p>
                <div className='line' />
                <div className={'paddle pru_paddle' + ( this.props.preferences.subscribedAlerts ? ' alert_enabled' : ' alert_disabled') }>
                  <Card>
                    <CardHeader>
                      <span className="master_alert_card_header">Turn all Alerts On or Off</span>
                      <span>
                        <ToggleSwitch id='tsGlobalAlerts' Name='tsGlobalAlerts' defaultChecked={this.props.preferences.subscribedAlerts} apiCallFunc={this.saveUserPreferences} text='Alerts' 
                        datagmupn='personalize'
                        datagmuc='alerts'
                        datagmue='masteralerts_toggle'
                        datagmua='click'/>
                      </span>
                    </CardHeader>
                    <CardBody>
                      <div className="card_body_row">
                        <div className="items_wrapper">
                          <span className='category_text'>Use this ‘master’ setting to switch off all active alerts or switch them back on in a single click. It’s a quick way to pause all alerts before going on vacation (whilst preserving your alert settings) or to permanently switch alerts off.</span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </div>
                <div className='line' />                
              </div>
              {this.props.preferences.subscribedAlerts ? 
                <div id='inner-container-preferences'>
                  <h3>Pre-set Content Set(s)</h3>
                  <div className='inner-container'>
                    {this.props.preferences.alertPreferences
                      .map((alertPreference, index) =>
                        alertPreference.type === "MajorDeal"
                        &&
                        <MajorDealPaddle key={alertPreference.id} id={alertPreference.id} name={alertPreference.name} alertPreference={alertPreference} />
                      )}
                  </div>
                  <div className='inner-container'>
                    {this.props.preferences.alertPreferences
                      .map((alertPreference, index) =>
                        alertPreference.type === "PressRoundUp"
                        &&
                        <PressRoundUpPaddle key={alertPreference.id} id={alertPreference.id} name={alertPreference.name} alertPreference={alertPreference} />
                      )}
                  </div>
                  <div className='line' />
                  <h3>Saved Searches and Portfolios</h3>
                  <SavedSearchPaddle />
                  <div className='inner-container'>
                    {this.props.preferences.alertPreferences
                      .map((alertPreference, index) =>
                        alertPreference.type === "Portfolio"
                        &&
                        <PortfolioPaddle key={alertPreference.id} id={alertPreference.id} name='Portfolio Alerts' alertPreference={alertPreference} />
                      )}
                  </div>
                  <div className='line' />
                  <div className='create-content-set-wrapper'>
                    <h3 className='create-content-set-wrapper-heading'>Customized Content Set(s)</h3>
                    <div className='content-set-button-wrapper' title={this.props.preferences.alertPreferences.length >= MAXCONTENTSETLIMIT
                      ? 'you have reached the maximum number of content sets' : 'create content set'}>
                      <a className='pure-button primary-action'
                        href={`/#/ContentSet`} target='_self' id='CreateContentSet'
                        disabled={this.props.preferences.alertPreferences.length >= MAXCONTENTSETLIMIT ? true : false}>
                        Create New Content Set
                      </a></div>
                  </div>
                  <p>Curate your own view of MLex content by creating Customized Content Set(s), each with its own email alerts.</p>
                  <div className='inner-container'>
                    {this.props.preferences.alertPreferences.sort((a, b) => a.name != null && b.name != null && a.name.localeCompare(b.name))
                      .map((alertPreference, index) =>
                        alertPreference.type === "General"
                        &&
                        <GeneralPaddle key={alertPreference.id} id={alertPreference.id} name={alertPreference.name} alertPreference={alertPreference} />
                      )}
                  </div>
                </div>
              : null }
            </div>
          )
        } else {
          return (
            <div className='content content-user-preferences grid-content-full'>
              <div className='inner-container'>
                <Skeleton height={40} count={1} /><br /><br />
                <Skeleton count={1} /><br /><br />
                <Skeleton count={10} /><br /><br />
              </div>
            </div>
          )
        }
      }
    } else {
      return (<div />)
    }
  }
}

function mapStateToProps(state) {
  return {
    user: state.oidc.user,
    preferences: state.userPreferences
  }
}

const mapDispatchToProps = (dispatch) => ({
  onFetch: () => new Promise((resolve, reject) => {
    dispatch(actions.fetchPreferences()).then(() => {
      resolve();
    })
  }),
  onSubmit(request) {
    dispatch(actions.updatePreferences(request))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserPreferences)
